<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouveau vendeur"
  (primaryClick)="openCreate(vendeurModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Vendeur</th>
          <th>Identifiant (PIN login)</th>
          <th>Téléphone</th>
          <th>Caisses associées</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="5">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading">
          <td>{{ vendeurLabel(row) }}</td>
          <td>{{ row.identifiant }}</td>
          <td>{{ row.telephone || '—' }}</td>
          <td>{{ caissesSummary(row) }}</td>
          <td class="d-flex align-items-center flex-nowrap">
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Modifier"
              (click)="openEdit(row, vendeurModal)"
            >
              <i data-feather="edit" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Caisses associées"
              (click)="openAssociation(row, assocModal)"
            >
              <i data-feather="link" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-danger"
              title="Supprimer"
              (click)="deleteRow(row)"
            >
              <i data-feather="trash-2" [size]="16"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="5">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #vendeurModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} vendeur</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" [formGroup]="form">
    <p class="text-muted small mb-3">
      Le vendeur se connecte sur la caisse avec son identifiant numérique et son code PIN (6 chiffres minimum).
    </p>
    <div class="form-group">
      <label>Identifiant (numérique)</label>
      <input class="form-control" formControlName="identifiant" inputmode="numeric" />
    </div>
    <div class="form-group">
      <label>Prénom</label>
      <input class="form-control" formControlName="prenom" />
    </div>
    <div class="form-group">
      <label>Nom</label>
      <input class="form-control" formControlName="nom" />
    </div>
    <div class="form-group">
      <label>Téléphone</label>
      <input class="form-control" formControlName="telephone" />
    </div>
    <div class="form-group mb-0">
      <label>Code PIN</label>
      <input type="password" class="form-control" formControlName="password" inputmode="numeric" />
      <small class="form-text text-muted" *ngIf="editId">
        Laissez vide pour conserver le code PIN actuel.
      </small>
      <small class="form-text text-muted" *ngIf="!editId">
        Minimum 6 chiffres (utilisé à la connexion caisse).
      </small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">
      Enregistrer
    </button>
  </div>
</ng-template>

<ng-template #assocModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Association vendeur / caisses</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-2" *ngIf="associationRow">
      Vendeur :
      <strong>{{ vendeurLabel(associationRow) }}</strong>
      <span class="text-muted">(identifiant {{ associationRow.identifiant }})</span>
    </p>
    <p class="text-muted small mb-3">
      Sélectionnez les caisses sur lesquelles ce vendeur pourra se connecter.
    </p>
    <div class="form-group mb-0">
      <label>Caisses</label>
      <ng-select
        [items]="caisseOptions"
        bindLabel="label"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        placeholder="Sélectionner des caisses"
        [(ngModel)]="associationCaisseIds"
      ></ng-select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveAssociation(modal)"
      [disabled]="associationSaving"
    >
      Enregistrer
    </button>
  </div>
</ng-template>
